module.exports = __webpack_public_path__ + "media/images/front/treatment_support/setting_add_home_screen/chrome-834cdd9653a787146e5c4ba0f6a66e5e.png";